<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container equipment-wrapper">
  <h2>Locations</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/location']">Location</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput id = "theSearch" (input)="doSpinner()" (keyup)="term$.next($event.target.value)" [(ngModel)]="searchLocation" name="search"
          placeholder="Enter an address, subdivision, lot number or plan name to search. " />
      </mat-form-field>
    </div>
  </form>
  <p style="text-align: center; color: lightslategray" *ngIf = "searchLocation">Search is active, clear to reset. </p>

  <div class="row ">
    <div class="d-flex col-md-4 col-sm-6 col-12 mb-3" *ngFor="let location of locations; let indexOfElement = index;">


<!--LAST-->
      <mat-card class="w-100 d-flex"  [style]="location.hvacerrors? 'background: #d60000;' : ''" *ngIf="indexOfElement + 1 === locations.length" #lastItem>
        <div class="equipment-wrapper__item w-100">
          <h2 class="equipment-wrapper__item__title">
            {{ location.subdivision_name || '(No Subdivision Name)' }}
          </h2>
          <div class="flex-grow-1">
            <p class="equipment-wrapper__item__detail">
              <b>Lot:</b> {{location.lot}}
            </p>
            <p class="equipment-wrapper__item__detail">
            <b>Address:</b> {{ location.street_address }}<br />
          </p>
          <p class="equipment-wrapper__item__detail">
            <b>City:</b> {{ location.city }}
          </p>
          <p class="equipment-wrapper__item__detail">
            <b>Plan:</b> {{location.plan_name}}
          </p>
        </div>
        <div class="flex-grow-1;" *ngIf="location.hvacnotes">
          <p style="color:black !important; font-size:14px;">Reviewers notes- </p>
          <i style='font-size:12px;'>{{location.hvacnotes || 'No notes left by reviewer.'}}</i>
        </div>
            <mat-form-field class="example-full-width" appearance="fill" *ngIf="!location.hvacerrors">
              <mat-label>Select Design</mat-label>
              <input type="text" (keyup)="searchDesign($event)" placeholder="" matInput
                [(ngModel)]="location.selectedDesign" [matAutocomplete]="auto" #selectDesign='ngModel' [ngModelOptions]="{standalone: true}">
              <mat-autocomplete #auto="matAutocomplete" [panelWidth]="'auto'"   [displayWith]="displaySelectedDesigns"
                autoActiveFirstOption>
                <mat-option [value]="">Designs</mat-option>
                <mat-option *ngFor="let design of designs" (click) ="checkValues(location.selectedDesign, location)"
                  [value]="design">
                  {{design?.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <button [disabled]="location.selectedDesign" (click)="openSubmissionModal(location, indexOfElement)"
            class="mt-auto view-design w-100 hover" color="default" *ngIf="location.hvacerrors" style="background: orange !important; border-radius: 9px;">
            Edit Submission
          </button>  <button [disabled]="location.selectedDesign" (click)="resetSubmission(location);"
          class="mt-auto view-design w-100 hover" color="default" *ngIf="location.hvacerrors" style="background: darkred !important; border-radius: 9px; margin-top:10px;">
          Reset
        </button>
            <button [disabled]="!location.selectedDesign" (click)="onDesignSelection(location.selectedDesign ,location, indexOfElement)" mat-flat-button
            class="mt-auto view-design w-100" color="primary" *ngIf="!location.hvacerrors">
            Confirm
          </button>
          <div class="mt-auto" hidden>
            <button [routerLink]="['/location-overview']" [queryParams]="{ id: location.location_id }" mat-flat-button
              class="mt-auto me-3 view-design" color="accent">
              View Location
            </button>
            <button mat-flat-button class="mt-auto select-location me-3" color="primary" [routerLink]="['/locations-select-designs']" [queryParams]="{ id: location.location_id }">
              Select Location
            </button>
          </div>
        </div>
      </mat-card>

<!--DEFAULT-->
      <mat-card class="w-100 d-flex" *ngIf="indexOfElement + 1 != locations.length" [style]="location.hvacerrors? 'background: #d60000;' : ''">
        <!--<mat-card class="w-100 d-flex" *ngIf="location?.plan_name.length" [style]="location.hvacerrors? 'background: #d60000;' : ''"> -->
        <div class="equipment-wrapper__item w-100">
          <h2 class="equipment-wrapper__item__title">
            {{ location.subdivision_name || '(No Subdivision Name)' }}
          </h2>
          <div class="flex-grow-1">
            <p class="equipment-wrapper__item__detail">
              <b>Lot:</b> {{location.lot}}
            </p>
            <p class="equipment-wrapper__item__detail">
            <b>Address:</b> {{ location.street_address }}<br />
          </p>
          <p class="equipment-wrapper__item__detail">
            <b>City:</b> {{ location.city }}
          </p>
          <p class="equipment-wrapper__item__detail">
            <b>Plan:</b> {{location.plan_name}}
          </p>
        </div>
        <div class="flex-grow-1;" *ngIf="location.hvacnotes">
          <p style="color:black !important; font-size:14px;">Reviewers notes- </p>
          <i style='font-size:12px;'>{{location.hvacnotes || 'No notes left by reviewer.'}}</i>
        </div>
            <mat-form-field class="example-full-width" appearance="fill" *ngIf="!location.hvacerrors">
              <mat-label>Select Design</mat-label>
              <input type="text" (keyup)="searchDesign($event)" placeholder="" matInput
                [(ngModel)]="location.selectedDesign" [matAutocomplete]="auto" #selectDesign='ngModel' [ngModelOptions]="{standalone: true}">
              <mat-autocomplete #auto="matAutocomplete" [panelWidth]="'auto'"   [displayWith]="displaySelectedDesigns"
                autoActiveFirstOption>
                <mat-option [value]="">Designs</mat-option>
                <mat-option *ngFor="let design of designs" (click) ="checkValues(location.selectedDesign, location)"
                  [value]="design">
                  {{design?.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <button [disabled]="location.selectedDesign" (click)="openSubmissionModal(location, indexOfElement)"
            class="mt-auto view-design w-100 hover" color="default" *ngIf="location.hvacerrors" style="background: orange !important; border-radius: 9px;">
            Edit Submission
          </button>  <button [disabled]="location.selectedDesign" (click)="resetSubmission(location);"
          class="mt-auto view-design w-100 hover" color="default" *ngIf="location.hvacerrors" style="background: darkred !important; border-radius: 9px; margin-top:10px;">
          Reset
        </button>
            <button [disabled]="!location.selectedDesign" (click)="onDesignSelection(location.selectedDesign ,location, indexOfElement)" mat-flat-button
            class="mt-auto view-design w-100" color="primary" *ngIf="!location.hvacerrors">
            Confirm
          </button>
          <div class="mt-auto" hidden>
            <button [routerLink]="['/location-overview']" [queryParams]="{ id: location.location_id }" mat-flat-button
              class="mt-auto me-3 view-design" color="accent">
              View Location
            </button>
            <button mat-flat-button class="mt-auto select-location me-3" color="primary" [routerLink]="['/locations-select-designs']" [queryParams]="{ id: location.location_id }">
              Select Location
            </button>
          </div>
        </div>
      </mat-card>





    </div>
  </div>


</div>
